import React from 'react';
import {Menu, MenuDividerProps} from '@mantine/core';

export const EtroMenuDivider: React.FC<MenuDividerProps> = props => {
  return <Menu.Divider {...props} />;
};
